import { render, staticRenderFns } from "./MktPlatforms.vue?vue&type=template&id=e058c256&"
import script from "./MktPlatforms.vue?vue&type=script&lang=ts&"
export * from "./MktPlatforms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports